export const objectToQueryString = (
  object: Record<string, string | number>,
) => {
  const searchParams = new URLSearchParams();

  Object.entries(object).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      searchParams.append(key, String(value));
      return;
    }
  });

  const queryString = searchParams.toString();

  return queryString;
};
